import {IconBase} from 'components/icons/_iconBase';
import {IconProps} from 'components/icons/types';
import {SITE} from 'features/ui/enums';
import * as React from 'react';
import {ResidenceType, StageStatus} from 'features/search/filters/enums';
import {getCurrentSite} from 'features/services/utils/env-helper';

import 'components/icons/GoogleMapsDot/style.scss';

interface Props extends IconProps {
    onClick?: () => void;
    stageStatus?: StageStatus;
    residenceType?: ResidenceType;
}

export const GoogleMapsDot: React.FunctionComponent<Props> = ({height, width, onClick, residenceType: _residenceType, stageStatus}) => {

    const getIconColor = () => {

        const currentSite = getCurrentSite();


        switch (currentSite) {
            case SITE.SENIORGARDEN:
                return '#003A68';
            case SITE.BORATT:
                return '#00517b';
            default:
                return '#d15c05';
        }


        switch (stageStatus) {
            case StageStatus.FORSALE:
                return '#6baa99';
            case StageStatus.PLANNED:
                return '#f6f6f4';
            case StageStatus.VIP:
                return '#F2B843';
            case StageStatus.SOLD_OUT:
                return '#e07357';
            default:
                return '#6baa99';
        }
    };

    const getIconStroke = () => {
        //if(stageStatus && stageStatus === StageStatus.PLANNED) return '#222220';

        return '#fff';
    };

    const internalOnClick = (e: React.MouseEvent<HTMLDivElement>) => {
        e.stopPropagation();
        if (onClick) onClick();
    };

    return (
        <div className="icon--google-maps-dot" onClick={internalOnClick}>
            <IconBase viewPortWidth={23} viewPortHeight={23} height={height} width={width}>
                <>
                    <defs>
                        <circle id="b" cx="1041.5" cy="505.5" r="7.5"/>
                        <filter id="a" width="180%" height="180%" x="-40%" y="-26.7%" filterUnits="objectBoundingBox">
                            <feMorphology in="SourceAlpha" operator="dilate" radius=".5" result="shadowSpreadOuter1"/>
                            <feOffset dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"/>
                            <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="1.5"/>
                            <feComposite in="shadowBlurOuter1" in2="SourceAlpha" operator="out" result="shadowBlurOuter1"/>
                            <feColorMatrix in="shadowBlurOuter1" values="0 0 0 0 0.247058824 0 0 0 0 0.247058824 0 0 0 0 0.235294118 0 0 0 0.2 0"/>
                        </filter>
                    </defs>
                    <g fill="none" fillRule="evenodd" transform="translate(-1030 -496)">
                        <use fill="#000" filter="url(#a)" xlinkHref="#b"/>
                        <use fill={getIconColor()} stroke={getIconStroke()} xlinkHref="#b"/>
                    </g>
                </>
            </IconBase>
        </div>

    );
};
